<template>
  <div class="layout-box">
    <div class="layout-box__container">
      <div class="layout-box__header">
        <PlayLogoVerticalSvg />
      </div>

      <div class="layout-box__body">
        <BoxLogin />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginView'
}
</script>
